import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { nwasSSOAvailableAtom } from "@state/State";
import { CONFIG_BUCKET_BASE } from "../../Constants";

export const useNWASSSO = (loadData: boolean = false) => {
  const [available, setAvailable] = useRecoilState<boolean>(nwasSSOAvailableAtom);

  useEffect(() => {
    if (loadData) {
      const checkIfSSOAvailable = async (): Promise<void> => {
        try {
          const response: Response = await fetch(`${CONFIG_BUCKET_BASE}/nwasSSO.json`, {
            headers: {
              "Cache-Control": "no-cache",
            },
          });

          const result = await response.json();

          if (result != null) {
            setAvailable(true);
          }
        } catch (error) {
          setAvailable(false);
        }
      };

      checkIfSSOAvailable();
    }
  }, [loadData]);

  return available;
};
